import { createApp } from "vue";
import "./registerServiceWorker";
import App from "./App.vue";
import router from "./router";
import VueMask from "@devindex/vue-mask";
import { api } from "roboflex-thalamus-request-handler";
import store from "./store";
import "./assets/css/thalamus.css";
import { aplicarInicioPwaAgenda } from "./utils/pwa-agenda-inicio";

api.defaults.baseURL = process.env.VUE_APP_ROOT_API;

const app = createApp(App).use(store);
app.config.globalProperties.$moduleName = "Acesso";
app.use(router);
app.use(VueMask);

router.isReady().then(async () => {
  try {
    await aplicarInicioPwaAgenda(router);
  } catch (_) {
    /* não bloquear mount */
  }
  app.mount("#app");
});
